import { useEffect, useState } from "react";
import { X, Megaphone } from "lucide-react";
import { api } from "../lib/api";

const DISMISSED_KEY = "ha_announcement_dismissed_id";

/**
 * Fetches the platform's active announcement and shows it as a modal popup
 * once per announcement id. If the admin clears or replaces the announcement,
 * every member sees the new one on their next page load.
 */
export default function AnnouncementModal() {
  const [a, setA] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get("/settings/public").then((r) => {
      if (cancelled) return;
      const ann = (r.data || {}).active_announcement;
      if (!ann || !ann.id) return;
      if (localStorage.getItem(DISMISSED_KEY) === ann.id) return;
      setA(ann);
    }).catch(() => {});
    return () => { cancelled = true; };
  }, []);

  function close() {
    if (a?.id) localStorage.setItem(DISMISSED_KEY, a.id);
    setA(null);
  }

  if (!a) return null;
  return (
    <div className="announcement-overlay" role="dialog" aria-modal="true" data-testid="member-announcement-modal">
      <div className="announcement-modal">
        <button className="announcement-close" onClick={close} aria-label="Close" data-testid="member-announcement-close">
          <X size={18} />
        </button>
        <div className="announcement-icon"><Megaphone size={22} /></div>
        <span className="eyebrow">ANNOUNCEMENT</span>
        <h3 data-testid="member-announcement-title">{a.title || "Announcement"}</h3>
        <p data-testid="member-announcement-text">{a.text}</p>
        <small>{new Date(a.posted_at).toLocaleString()}</small>
        <button className="btn btn-accent full" onClick={close} data-testid="member-announcement-dismiss">Got it</button>
      </div>
    </div>
  );
}
